module.exports = __webpack_public_path__ + "images/new_life_insurance_icon.0636d92dd9fef1b4391da4c82d348521.png";